// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Skills_Skills__PZMce {
  padding: 2.5rem;
  margin-bottom: 5vh;
}
.Skills_Skills__PZMce .Skills_programmingSkillsContainer__HeUNF {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Skills_Skills__PZMce .Skills_programmingSkillsContainer__HeUNF .Skills_programmingSkillsHeader__3mHWn {
  font-size: 1.8rem;
  text-decoration: underline;
}
@media only screen and (max-width: 768px) {
  .Skills_Skills__PZMce .Skills_programmingSkillsContainer__HeUNF .Skills_programmingSkillsHeader__3mHWn {
    font-size: 1.2rem;
  }
}
.Skills_Skills__PZMce .Skills_programmingSkillsContainer__HeUNF .Skills_programmingSkillsRowContainer__zpJrX {
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
}
.Skills_Skills__PZMce .Skills_programmingSkillsContainer__HeUNF .Skills_programmingSkillsRow__LnikK {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.Skills_Skills__PZMce .Skills_programmingSkillsContainer__HeUNF .Skills_programmingSkillsToggleContainer__0QlLv {
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-bottom: 2rem;
}
.Skills_Skills__PZMce .Skills_programmingSkillsContainer__HeUNF .Skills_programmingSkillsToggleImages__EEccT {
  display: flex;
}
.Skills_Skills__PZMce .Skills_programmingSkillsContainer__HeUNF .Skills_programmingSkillsToggleImages__EEccT img {
  width: 1rem;
  height: 1rem;
}
.Skills_Skills__PZMce .Skills_otherSkillsContainer__VeaxD {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.Skills_Skills__PZMce .Skills_otherSkillsContainer__VeaxD .Skills_otherSkillsHeader__wa1XH {
  text-align: center;
  text-decoration: underline;
  font-size: 1.8rem;
}
@media only screen and (max-width: 768px) {
  .Skills_Skills__PZMce .Skills_otherSkillsContainer__VeaxD .Skills_otherSkillsHeader__wa1XH {
    font-size: 1.2rem;
  }
}
.Skills_Skills__PZMce .Skills_otherSkillsContainer__VeaxD .Skills_otherSkillsHeader__wa1XH {
  padding-bottom: 1.25rem;
}
.Skills_Skills__PZMce .Skills_otherSkillsContainer__VeaxD .Skills_otherSkillsContent__bS3ZQ {
  display: flex;
  flex-direction: column;
}
.Skills_Skills__PZMce .Skills_darkTheme__YFnXE {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 1rem;
}
.Skills_Skills__PZMce .Skills_lightTheme__5yDSo {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  border-radius: 1rem;
}
.Skills_Skills__PZMce .Skills_colorfulTheme__MHYTR {
  padding: inherit;
  border-radius: inherit;
  background-color: rgba(208, 209, 255, 0.5);
  border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/views/Skills/Skills.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAEA;EACE,eCCkC;EDAlC,kBAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAGI;EACE,iBAAA;EACA,0BAAA;AADN;AAEM;EAHF;IAII,iBCfS;EDgBf;AACF;AAGI;EACE,mBCnBe;EDoBf,aAAA;EACA,sBAAA;AADN;AAUI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AARN;AAWI;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;AATN;AAYI;EACE,aAAA;AAVN;AAYM;EACE,WAAA;EACA,YAAA;AAVR;AAeE;EACE,mBCvDgC;EDwDhC,sBCxDgC;EDyDhC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;AAeI;EACE,kBAAA;EACA,0BAAA;EACA,iBAAA;AAbN;AAcM;EAJF;IAKI,iBCtES;ED2Df;AACF;AAKI;EAOE,uBAAA;AATN;AAYI;EACE,aAAA;EACA,sBAAA;AAVN;AAkBE;EC7BA,gBAAA;EACA,sBAAA;EACA,2CAnD4B;ED2E1B,mBChFiB;ADuErB;AAiBE;EC5BA,gBAAA;EACA,sBAAA;EACA,0CAxD6B;ED0E3B,mBChFiB;AD6ErB;AAgBE;EC3BA,gBAAA;EACA,sBAAA;EACA,0CA9D6B;ED0E3B,mBChFiB;ADmFrB","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.Skills {\n  padding: $globalHomeContentContainerPadding;\n  margin-bottom: 5vh;\n\n  .programmingSkillsContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    .programmingSkillsHeader {\n      font-size: $globalFontSize * 1.5;\n      text-decoration: underline;\n      @media only screen and (max-width: 768px) {\n        font-size: $globalFontSize;\n\n      }\n    }\n\n    .programmingSkillsRowContainer {\n      border-radius: $globalBorderRadius;\n      display: flex;\n      flex-direction: column;\n\n      &:hover {\n        //--pulse-color: var(--pulse-color-skills);\n        //@include globalPulseAnimationMixin;\n      }\n    }\n\n\n    .programmingSkillsRow {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .programmingSkillsToggleContainer {\n      display: flex;\n      flex-direction: column;\n      padding-top: 1rem;\n      padding-bottom: 2rem;\n    }\n\n    .programmingSkillsToggleImages {\n      display: flex;\n\n      img {\n        width: 1rem;\n        height: 1rem;\n      }\n    }\n  }\n\n  .otherSkillsContainer {\n    padding-top: $globalHomeContentContainerPadding;\n    padding-bottom: $globalHomeContentContainerPadding;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    .otherSkillsHeader {\n      text-align: center;\n      text-decoration: underline;\n      font-size: $globalFontSize * 1.5;\n      @media only screen and (max-width: 768px) {\n        font-size: $globalFontSize;\n      }\n      padding-bottom: calc($globalHomeContentContainerPadding / 2);\n    }\n\n    .otherSkillsContent {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  @mixin contentStyling {\n    border-radius: $globalBorderRadius;\n  }\n\n  .darkTheme {\n    @include darkThemeContent;\n    @include contentStyling;\n  }\n\n  .lightTheme {\n    @include lightThemeContent;\n    @include contentStyling;\n  }\n\n  .colorfulTheme {\n    @include colorfulThemeContent;\n    @include contentStyling;\n  }\n}","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Skills": `Skills_Skills__PZMce`,
	"programmingSkillsContainer": `Skills_programmingSkillsContainer__HeUNF`,
	"programmingSkillsHeader": `Skills_programmingSkillsHeader__3mHWn`,
	"programmingSkillsRowContainer": `Skills_programmingSkillsRowContainer__zpJrX`,
	"programmingSkillsRow": `Skills_programmingSkillsRow__LnikK`,
	"programmingSkillsToggleContainer": `Skills_programmingSkillsToggleContainer__0QlLv`,
	"programmingSkillsToggleImages": `Skills_programmingSkillsToggleImages__EEccT`,
	"otherSkillsContainer": `Skills_otherSkillsContainer__VeaxD`,
	"otherSkillsHeader": `Skills_otherSkillsHeader__wa1XH`,
	"otherSkillsContent": `Skills_otherSkillsContent__bS3ZQ`,
	"darkTheme": `Skills_darkTheme__YFnXE`,
	"lightTheme": `Skills_lightTheme__5yDSo`,
	"colorfulTheme": `Skills_colorfulTheme__MHYTR`
};
export default ___CSS_LOADER_EXPORT___;
